module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../node_modules/happypack/loader.js?id=jsx!./WechatBackLoginAuthView.js"));
	}, "WechatBackLoginAuthView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=WechatBackLoginAuthView!./src/pages/Shop/WechatAuth/WechatBackLoginAuthView.js
// module id = 1808
// module chunks = 367